<template>
  <div id="loading-mid" v-show="loadingShow">
    <div class="mask"></div>
    <div class="toast">
      <img src="../../assets/icon/gif/oval.svg" clss="mid-icon" />
    </div>
  </div>
</template>



<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    loadingShow: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
#loading-mid {
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(27, 27, 27, 0.5);
    z-index: 1200;
  }
  .toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1201;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img {
      width: 40px;
    }
    p {
      color: #fff;
      height: 20px;
      margin-top: 14px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LoadingMiddle.vue?3b5f4c67